import React, { useContext, useMemo } from 'react';

export interface CardErrorProps {
  error: string;
}

export const CardErrorContext = React.createContext<CardErrorProps>({ error: '' });

export const CardErrorProvider: React.FC<React.PropsWithChildren<CardErrorProps>> = ({ error, children }) => {
  const value = useMemo(() => ({ error }), [error]);

  return (
    <CardErrorContext.Provider value={value}>
      {children}
    </CardErrorContext.Provider>
  );
};

export const useCardErrorContext = (): CardErrorProps => {
  const context = useContext(CardErrorContext);

  if (!context) {
    throw new Error('useCardErrorContext must be used within a CardErrorProvider');
  }

  return context;
};

export function withErrorContext<TProps>(Component: React.FC<TProps>) {
  const FormCard: React.FC<TProps & CardErrorProps> = ({ error, ...rest }) => (
    <CardErrorProvider error={error}>
      <Component {...(rest as any)} />
    </CardErrorProvider>
  );

  return FormCard;
}
